import React from 'react';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

import { Button } from 'components/ui/button';
import type { CallTemplate } from 'bundles/connect/types';
import { Col, ListGroup, Row } from 'react-bootstrap-5';
import { displayToast } from '../../helpers/display_toast';
import { deleteCallTemplate } from '../../helpers/prospect_api';

type CallTemplateRowProps = {
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setTemplate: React.Dispatch<React.SetStateAction<CallTemplate>>;
  setTemplates: React.Dispatch<React.SetStateAction<CallTemplate[]>>;
  template: CallTemplate;
}
export default function CallTemplateRow({ setShow, setTemplate, setTemplates, template }: CallTemplateRowProps) {
  const handleDelete = async (id: number) => {
    confirm('Are you sure you want to delete this template?') && await deleteCallTemplate(id)
      .then(() => {
        displayToast('Call Template successfully deleted', 'success');
        setTemplates(prevTemplates => prevTemplates.filter(template => template.id !== id));
      });
  };

  const handleClick = () => {
    setTemplate(template);
    setShow(true);
  };

  return (
    <ListGroup.Item>
      <Row className="align-items-center d-flex flex-grow-1">
        <Col className="text-truncate">
          <Button className="p-0" variant="ghost" onClick={handleClick}>
            <strong>{template.title}</strong>
          </Button>
        </Col>
        <Col xs="auto">
          <Button icon={faTrash} variant="secondary" onClick={() => handleDelete(template.id)} />
        </Col>
      </Row>
    </ListGroup.Item>
  );
}
